import React from 'react';

export default function ProfilePage() {
  return (
    <div className="page profile-page">
      Profile
    </div>
  );
}
